// extracted by mini-css-extract-plugin
module.exports = {"videoCardWrapper":"styles_videoCardWrapper__cCroW","videoTitle":"styles_videoTitle__2yJ4b","videoDescr":"styles_videoDescr__2E1N4"};